module.exports = __webpack_public_path__ + "img/case-banner__img2.png?6eaa7d525d7d8266e264adf16ff91603";